<template>
  <CRow>
    <CCol col="12">
      <CCard class="bg-style2">
        <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
          <span class="font-weight-bold h6">
            <CIcon name="cil-chart-pie" class="mr-2"/>
            ความต้องการอบรมในห้องเรียน ปี {{ year }}
          </span>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol md="4" sm="12" class="mb-3">
              <CCard class="border-left-danger h-100">
                <CCardBody class="text-center">
                  <div class="text-muted small">จำนวนหลักสูตร</div>
                  <div class="display-4 font-weight-bold">{{ summary.totalCourses || 0 }}</div>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md="4" sm="12" class="mb-3">
              <CCard class="border-left-warning h-100">
                <CCardBody class="text-center">
                  <div class="text-muted small">จำนวนการเลือกหลักสูตร</div>
                  <div class="display-4 font-weight-bold">{{ summary.totalSelections || 0 }}</div>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md="4" sm="12" class="mb-3">
              <CCard class="border-left-info h-100">
                <CCardBody class="text-center">
                  <div class="text-muted small">จำนวนบุคลากร</div>
                  <div class="display-4 font-weight-bold">{{ summary.totalPeople || 0 }}</div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: "TrainingDemandSummary",
  props: {
    summary: {
      type: Object,
      default() {
        return {
          totalCourses: 0,
          totalSelections: 0,
          totalPeople: 0
        };
      }
    },
    year: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.border-left-danger {
  border-left: 4px solid #e55353;
}

.border-left-warning {
  border-left: 4px solid #f9b115;
}

.border-left-info {
  border-left: 4px solid #39f;
}
</style>
